module.exports = __webpack_public_path__ + "img/search_button_search_down.bf31ac38.png";